import { defineStore } from 'pinia'
import { getStorage, setStorage } from '@/utils/storage'

export const useAppStore = defineStore('app', {
  state: () => ({
    theme: getStorage('theme') || 'light',
    loading: false,
    loadingText: '',
    notification: null
  }),

  actions: {
    setTheme(theme) {
      this.theme = theme
      setStorage('theme', theme)
      document.documentElement.setAttribute('data-theme', theme)
    },

    toggleTheme() {
      this.setTheme(this.theme === 'dark' ? 'light' : 'dark')
    },

    setLoading(loading, text = '') {
      this.loading = loading
      this.loadingText = text
    },

    showNotification(type, message) {
      this.notification = { type, message, timestamp: Date.now() }
    }
  }
})
